module.exports = __webpack_public_path__ + "static/media/calendar.dad10b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/calendar.png
// module id = 231
// module chunks = 0